// import axios from 'axios';

// // Action Types
// export const USER_ACTIONS = {
//   SET_USERS: 'SET_USERS',
//   ADD_USER: 'ADD_USER',
//   DELETE_USER: 'DELETE_USER',
//   UPDATE_USER_PERMISSIONS: 'UPDATE_USER_PERMISSIONS', 
//   UPDATE_USER_ROLE: 'UPDATE_USER_ROLE'
// };

// // Action Creators

// // Fetch all users
// export const fetchUsers = () => async (dispatch) => {
//   try {
//     const response = await axios.get(`https://cloudify-prod.wizr.in/api/users`);
//     dispatch({ type: USER_ACTIONS.SET_USERS, payload: response.data });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching users:', error);
//     throw error;
//   }
// };

// // Create user
// export const createUser = (userData) => async (dispatch) => {
//   try {
//     const response = await axios.post(`https://cloudify-prod.wizr.in/api/users`, userData);
//     dispatch({type: USER_ACTIONS.ADD_USER, payload: response.data});
//     return response.data;
//   } catch (error) {
//     console.error('Error creating user:', error);
//     throw error;
//   }
// };


// // Delete user
// export const deleteUser = (userId) => async (dispatch) => {
//   try {
//     await axios.delete(`https://cloudify-prod.wizr.in/api/users/${userId}`);
//     dispatch({type: USER_ACTIONS.DELETE_USER, payload: userId});
//   } catch (error) {
//     console.error('Error deleting user:', error);
//     throw error;
//   }
// };

// // Update user role
// export const updateUserRole = (userId, role) => async (dispatch) => {
//   try {
//     const response = await axios.put(`https://cloudify-prod.wizr.in/api/users/${userId}/role`, { role });
//     dispatch({ type: USER_ACTIONS.UPDATE_USER_ROLE, payload: response.data});
//     return response.data;
//   } catch (error) {
//     console.error('Error updating user role:', error);
//     throw error;
//   }
// };

// // Update user permissions for a specific application
// export const updateUserPermissions = (userId, appId, permissions) => async (dispatch) => {
//   try {
        
//     const response = await axios.put( `https://cloudify-prod.wizr.in/api/users/${userId}/${appId}/permissions`,{ permissions },
//       {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       }
//     );
    
//     dispatch({type: USER_ACTIONS.UPDATE_USER_PERMISSIONS, payload: response.data});
//     return response.data;
//   } catch (error) {
//     console.error('Error updating user permissions:', error.response || error);
//     throw error;
//   }
// };




import axios from 'axios';

// Action Types
export const USER_ACTIONS = {
  SET_USERS: 'SET_USERS',
  ADD_USER: 'ADD_USER',
  DELETE_USER: 'DELETE_USER',
  UPDATE_USER_PERMISSIONS: 'UPDATE_USER_PERMISSIONS',
  UPDATE_USER_ROLE: 'UPDATE_USER_ROLE',
  UPDATE_PROJECT_ROLE: 'UPDATE_PROJECT_ROLE'
};

// Base API URL
const API_BASE_URL = 'https://cloudify-prod.wizr.in/api';

// Fetch all users
export const fetchUsers = () => async (dispatch) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users`);
    dispatch({ type: USER_ACTIONS.SET_USERS, payload: response.data });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Create user
export const createUser = (userData) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/users`, userData);
    dispatch({ type: USER_ACTIONS.ADD_USER, payload: response.data });
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

// Delete user
export const deleteUser = (userId) => async (dispatch) => {
  try {
    await axios.delete(`${API_BASE_URL}/users/${userId}`);
    dispatch({ type: USER_ACTIONS.DELETE_USER, payload: userId });
    return userId;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

// Update global user role
export const updateUserRole = (userId, role) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}/role`,
      { role }
    );
    dispatch({ 
      type: USER_ACTIONS.UPDATE_USER_ROLE, 
      payload: { userId, role }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

// Update project role for a user
export const updateProjectRole = (userId, projectId, role) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}/projects/${projectId}/role`,
      { role }
    );
    dispatch({
      type: USER_ACTIONS.UPDATE_PROJECT_ROLE,
      payload: { userId, projectId, role }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating project role:', error);
    throw error;
  }
};

// Update resource permissions within a project
export const updateResourcePermissions = ( userId, projectId, resourceId, permissions) => async (dispatch) => {
  try {
    const payload = typeof permissions === 'object' && !Array.isArray(permissions) 
      ? permissions 
      : { permissions };

    const response = await axios.put(
      `${API_BASE_URL}/users/${userId}/projects/${projectId}/resources/${resourceId}/permissions`,
      payload
    );

    // dispatch({
    //   type: USER_ACTIONS.UPDATE_USER_PERMISSIONS,
    //   payload: {
    //     userId,
    //     projectId,
    //     resourceId,
    //     permissions
    //   }
    // });

    return response.data;
  } catch (error) {
    console.error('Error updating resource permissions:', error);
    throw error;
  }
};

// Update multiple permissions at once (project role and/or resource permissions)
export const updateUserPermissions = (userId, permissionData) => async (dispatch) => {
  try {

    // Handle resource permissions if specified
    await dispatch(
      updateResourcePermissions(
        userId,
        permissionData.projectId,
        permissionData.resourceId,
        permissionData.permissions
      )
    );

    return { success: true };
  } catch (error) {
    console.error('Error updating user permissions:', error);
    throw error;
  }
};